var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "118px",
    height: "128px",
    viewBox: "0 0 118 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E00CEC77-DAF6-42F1-8DD0-BC0E4D926916@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Landing-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landing-Page",
    transform: "translate(-1127.000000, -738.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(968.000000, 699.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(160.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFD100",
    points: "58.2184113 9.30201342 17.1590542 26.3115083 0 67.2978592 16.4774152 109.027678 57.8856426 126 98.7786154 107.774403 115.932302 66.8039838 99.6427404 26.2743349"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-Copy",
    stroke: "#C3D7EE",
    points: "58.2184113 0 17.1590542 17.0094949 0 57.9958458 16.4774152 99.7256651 57.8856426 116.697987 98.7786154 98.4723898 115.932302 57.5019704 99.6427404 16.9723215"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.1926316,71.7936664 C63.0389474,70.0867542 63.0978947,68.8955158 63.0978947,67.3357876 C63.8663158,66.9302371 65.2431579,64.3444557 65.4757895,62.1599892 C66.08,62.1102219 67.0326316,61.5172499 67.3115789,59.1760693 C67.4621053,57.9191805 66.8642105,57.2118496 66.5,56.9894851 C67.4831579,54.0150952 69.5252632,44.8134404 62.7231579,43.8625674 C62.0231579,42.6257972 60.2305263,42 57.9010526,42 C48.5810526,42.1725972 47.4568421,49.0796621 49.5,56.9894851 C49.1368421,57.2118496 48.5389474,57.9191805 48.6884211,59.1760693 C48.9684211,61.5172499 49.92,62.1102219 50.5242105,62.1599892 C50.7557895,64.3433968 52.1873684,66.9302371 52.9578947,67.3357876 C52.9578947,68.8955158 53.0157895,70.0867542 52.8621053,71.7936664 C51.0178947,76.7809845 38.5747368,75.381147 38,85 L78,85 C77.4263158,75.381147 65.0368421,76.7809845 63.1926316,71.7936664 Z",
    id: "Path",
    stroke: "#2774AE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyInformation);
export default __webpack_public_path__ + "static/media/MyInformation.76f8236338eb35cd90ea768b783fb8ed.svg";
export { ForwardRef as ReactComponent };